import React, { useEffect, useRef, useState } from "react";
import MolGrid from "../../../../components/molGrid/MolGrid";
import {
  assignUnassignMergeGridConfig,
  unAssignUnassignMergeGridConfig,
} from "./assignUnassignMergeList.grid.config";
import SwalAlert from "../../../../services/swalService/SwalService";
import CardSection from "../../../../components/ui/card/CardSection";
import { useAssignedLiabilityBasicMutation, useLazyGetAssignedLiabilityBasicQuery, useLazyGetLiabilityBasicTypeByIdQuery, useLazyGetUnassignedLiabilityBasicQuery, useUnassignedLiabilityBasicMutation } from "../../../../app/services/liabilityTypesAPI";
import ToastService from "../../../../services/toastService/ToastService";
import PropTypes from "prop-types";

const AssignUnassignMergeField = (props) => {
  const molGridRef = useRef();
  const { error } = SwalAlert();
  const [totalCount, setTotalCount] = useState([]);
  const [unassignedDataSource, setUnassignedDataSource] = useState([]);
  const [assignedDataSource, setAssignedDataSource] = useState([]);
  const [selectedAssignedList, setSelectedAssignedList] = useState([]);
  const [selectedUnassignedList, setSelectedUnassignedList] = useState([]);
  const [sortState, setSortState] = useState([]);

  const [GetUnassignedLiabilityBasic, {
    isLoading: isUnassignedLiabilityBasicFetching,
    isSuccess: isUnassignedLiabilityBasicFetched,
    data: unassignedLiabilityBasicData
  }] = useLazyGetUnassignedLiabilityBasicQuery();

  const [GetAssignedLiabilityBasic, {
    isLoading: isassignedLiabilityBasicFetching,
    isSuccess: isassignedLiabilityBasicFetched,
    data: assignedLiabilityBasicData
  }] = useLazyGetAssignedLiabilityBasicQuery();

  const [unassignedLiabilityBasic, {
    isLoading: isunassignedLiabilityBasicDeleting,
    isSuccess: isunassignedLiabilityBasicDeleted,
    data: unassignedLiabilityBasicDeletedData
  }] = useUnassignedLiabilityBasicMutation();

  const [assignedLiabilityBasic, {
    isLoading: isassignedLiabilityBasicAdding,
    isSuccess: isassignedLiabilityBasicAdded,
    data: assignedLiabilityBasicAddedData
  }] = useAssignedLiabilityBasicMutation()

  const [getLiabilityBasicTypeListById, {
    isLoading: isLiabilityBasicTypeListFetching,
    isSuccess: isLiabilityBasicTypeListSuccess,
    data: liabilityBasicTypeListData
}] = useLazyGetLiabilityBasicTypeByIdQuery();

  useEffect(() => {
    if (props.selectRow) {
      getList()
    }
  }, [props.selectRow]);

  const sortUnAssignData = (data, sortState) => {
      
    return [...data].sort((a, b) => {
        for (const sort of sortState) {
            const valA = a[sort.column] ?? '';
            const valB = b[sort.column] ?? '';
            const comparison = sort.direction === 'asc' 
                ? valA.toString().localeCompare(valB.toString())
                : valB.toString().localeCompare(valA.toString());
            if (comparison !== 0) return comparison;
        }
        return 0;
    });
};

const handleUnAssignSortingChange = async(sortString,col) => {
  if (!sortString) return;    
  const newSortState = sortString
      .split(',')
      .map(item => {
          const [column, directionRaw] = item.trim().split(/\s+/); 
          const direction = directionRaw?.toLowerCase() === 'desc' ? 'desc' : 'asc';
          return { column, direction };
      })
      .filter(item => item.column); 
      const filtered = newSortState.filter(item => item.column === col.fieldName);
      setSortState(newSortState);
      const orderData = await sortUnAssignData(assignedDataSource,filtered);
      setAssignedDataSource(orderData);
};

  const sortAssignData = (data, sortState) => {
      
    return [...data].sort((a, b) => {
        for (const sort of sortState) {
            const valA = a[sort.column] ?? '';
            const valB = b[sort.column] ?? '';
            const comparison = sort.direction === 'asc' 
                ? valA.toString().localeCompare(valB.toString())
                : valB.toString().localeCompare(valA.toString());
            if (comparison !== 0) return comparison;
        }
        return 0;
    });
};

const handleAssignSortingChange = async(sortString,col) => {
  if (!sortString) return;    
  const newSortState = sortString
      .split(',')
      .map(item => {
          const [column, directionRaw] = item.trim().split(/\s+/); 
          const direction = directionRaw?.toLowerCase() === 'desc' ? 'desc' : 'asc';
          return { column, direction };
      })
      .filter(item => item.column); 
      const filtered = newSortState.filter(item => item.column === col.fieldName);
      setSortState(newSortState);
      const orderData = await sortAssignData(unassignedDataSource,filtered);
      setUnassignedDataSource(orderData);
};

  const getList = () => {
    const req = props?.selectRow;
    setAssignedDataSource([])
    setUnassignedDataSource([])
    GetAssignedLiabilityBasic(req);
    GetUnassignedLiabilityBasic(req);
  }


  const handleEditClick = (data) => {
    props.onEdit?.(data);
  };
  const handleViewClick = (data) => {
    props.onView?.(data);
  };

  const handleAssignListToggleChange = (fieldName, newRowData, rowIndex) => {
    setSelectedUnassignedList((prevList) => {
      const exists = prevList.find((item) => item.id === newRowData.id);

      if (newRowData.choose && !exists) {
        return [...prevList, newRowData];
      } else if (!newRowData.choose && exists) {
        return prevList.filter((item) => item.id !== newRowData.id);
      }
      return prevList; 
    });
  };

  const handleUnassignListToggleChange = (fieldName, newRowData, rowIndex) => {
    setSelectedAssignedList((prevList) => {
      const exists = prevList.find((item) => item.id === newRowData.id);

      if (newRowData.choose && !exists) {
        return [...prevList, newRowData];
      } else if (!newRowData.choose && exists) {
        return prevList.filter((item) => item.id !== newRowData.id);
      }

      return prevList;
    });
  };


  const handleAssignClick = () => {
    if (selectedUnassignedList.length > 0) {
      const payload = {
        liabilitytypeid: props.selectRow,
        basistypeid: selectedUnassignedList.map((item) => String(item.id)).join(","),  
      };
      assignedLiabilityBasic(payload);
      setSelectedUnassignedList([])
      setSelectedAssignedList([])
    }
  };


  const handleUnassignClick = () => {
    if (selectedAssignedList.length > 0) {
    const payload = {
      liabilitytypeid:Number(props.selectRow),
      basistypeid: selectedAssignedList.map((item) => String(item.id)).join(","),
    };
    unassignedLiabilityBasic(payload);
    setSelectedUnassignedList([])
    setSelectedAssignedList([])
  }
  };


  useEffect(() => {
    if (isassignedLiabilityBasicAdded && assignedLiabilityBasicAddedData) {
      if (assignedLiabilityBasicAddedData?.errorMessage?.includes('exist')) {
        ToastService.warning(assignedLiabilityBasicAddedData.errorMessage);
      } else {
        ToastService.success(assignedLiabilityBasicAddedData.errorMessage);
      }
      GetAssignedLiabilityBasic(props?.selectRow);
      GetUnassignedLiabilityBasic(props?.selectRow);
  
    }
  }, [isassignedLiabilityBasicAdded, assignedLiabilityBasicAddedData]);

  useEffect(() => {
    if (
      !isUnassignedLiabilityBasicFetching &&
      isUnassignedLiabilityBasicFetched &&
      unassignedLiabilityBasicData
    ) {
      setUnassignedDataSource(unassignedLiabilityBasicData);
    }
  }, [
    isUnassignedLiabilityBasicFetching,
    isUnassignedLiabilityBasicFetched,
    unassignedLiabilityBasicData,
  ]);

  useEffect(() => {
    if (
      !isassignedLiabilityBasicFetching &&
      isassignedLiabilityBasicFetched &&
      assignedLiabilityBasicData
    ) {
      setAssignedDataSource(assignedLiabilityBasicData);
      getLiabilityBasicTypeListById(props?.selectRow)
    }
  }, [
    isassignedLiabilityBasicFetching,
    isassignedLiabilityBasicFetched,
    assignedLiabilityBasicData,
  ]);

  useEffect(() => {
    if (isunassignedLiabilityBasicDeleted && unassignedLiabilityBasicDeletedData) {
      if (unassignedLiabilityBasicDeletedData?.errorMessage?.includes("The DELETE statement")) {
        error(unassignedLiabilityBasicDeletedData?.errorMessage).then((confirmed) => {
          if (confirmed) {   
        
          }
        });
      }else{
        ToastService.success(unassignedLiabilityBasicDeletedData?.errorMessage);
      }
      GetAssignedLiabilityBasic(props?.selectRow);
      GetUnassignedLiabilityBasic(props?.selectRow);  
      getLiabilityBasicTypeListById(props?.selectRow)
    }     
  }, [isunassignedLiabilityBasicDeleted, unassignedLiabilityBasicDeletedData]);

  useEffect(() => {
    if (isLiabilityBasicTypeListSuccess && liabilityBasicTypeListData) {
      props?.setListData(liabilityBasicTypeListData);
    }
  }, [isLiabilityBasicTypeListSuccess, liabilityBasicTypeListData]);

  const actionHandler = {
    EDIT: handleEditClick,
    VIEW: handleViewClick,
  };
  return (
    <>
      <div className="assign-unassign-sec">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-12">
            <CardSection
              cardTitle={"Unassigned Merge Field Screen"}
              rightButton={true}
              buttonClassName={"blue-btn"}
              titleButtonClick={handleAssignClick}
              buttonText={"Assign"}
              searchInput={false}
              isButtonVisible={true}
              isButtonLoading={""}
              isIcon={true}
              iconClass="ri:expand-right-line"
              isDisable={selectedUnassignedList.length > 0 ? false :true}
            >
              <div className="grid-section">
                <MolGrid
                  ref={molGridRef}
                  configuration={unAssignUnassignMergeGridConfig}
                  dataSource={unassignedDataSource}
                  allowPagination={false}
                  pagination={{
                    totalCount: totalCount,
                    pageSize: 20,
                    currentPage: 1,
                  }}
                  onActionChange={actionHandler}
                  isLoading={isUnassignedLiabilityBasicFetching || isunassignedLiabilityBasicDeleting || isassignedLiabilityBasicAdding}
                  onColumnChange={handleAssignListToggleChange}
                  onSorting = {handleAssignSortingChange}
                />
              </div>
            </CardSection>
          </div>
          <div className="col-xl-6 col-lg-6 col-12">
            <CardSection
              cardTitle={"Assigned Merge Field Screen"}
              rightButton={true}
              buttonClassName={"blue-btn"}
              titleButtonClick={handleUnassignClick}
              buttonText={"Unassign"}
              searchInput={false}
              isButtonVisible={true}
              isButtonLoading={""}
              isIcon={true}
              iconClass="ri:expand-left-line"
              isDisable={selectedAssignedList?.length > 0 ? false : true}
            >
              <div className="grid-section">
                <MolGrid
                  ref={molGridRef}
                  configuration={assignUnassignMergeGridConfig}
                  dataSource={assignedDataSource}
                  allowPagination={false}
                  pagination={{
                    totalCount: totalCount,
                    pageSize: 20,
                    currentPage: 1,
                  }}
                  onActionChange={actionHandler}
                  isLoading={isUnassignedLiabilityBasicFetching || isunassignedLiabilityBasicDeleting || isassignedLiabilityBasicAdding}
                  onColumnChange={handleUnassignListToggleChange} 
                  onSorting = {handleUnAssignSortingChange}
                />
              </div>
            </CardSection>
          </div>
        </div>
      </div>
    </>
  );
};

AssignUnassignMergeField.propTypes = {
  selectRow: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  onEdit: PropTypes.func,     
  onView: PropTypes.func,   
  setListData: PropTypes.func 
};

export default AssignUnassignMergeField;
